import { useController } from 'react-hook-form';
import { ActionButtonToggle } from 'modules/placements/types';
import { reformatLabelForId } from 'modules/placements/utils';
import { useEffect, useState } from 'react';
import { BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { Edit16 } from 'ui/icons';
import { TOGGLE_SIZES, Toggle } from 'ui/toggle';
import { InputText } from 'ui/inputs';
import { ToggleRow, TogglesContainer } from './styles';

export const ActionButtonToggles = () => {
  const {
    field: { onChange: setActionButtons, value: actionButtons },
  } = useController({
    name: 'actionButtons',
  });

  const [isEditingTitles, setIsEditingTitles] = useState(
    Array(actionButtons.length).map(() => false),
  );

  const handleUpdateToggles = (fieldName: string, value: boolean | string, index: number) => {
    const updatedToggleStates = [...actionButtons];
    updatedToggleStates[index] = { ...updatedToggleStates[index], [fieldName]: value };
    setActionButtons(updatedToggleStates);
  };

  const handleUpdateIsEditingStates = (value: boolean, index: number) => {
    const updatedIsEditingStates = [...isEditingTitles];
    updatedIsEditingStates[index] = value;
    setIsEditingTitles(updatedIsEditingStates);
  };

  const handleUpdateToggleState = (index: number, value?: boolean) =>
    typeof value !== 'undefined' ? handleUpdateToggles('isActive', value, index) : null;

  const handleUpdateName = (value: string, index: number) =>
    handleUpdateToggles('title', value, index);

  useEffect(() => {
    isEditingTitles.forEach((isEditing, index) => {
      if (!isEditing && actionButtons[index].title.length === 0)
        handleUpdateName(`Button ${index + 1}`, index);
    });
  }, [isEditingTitles]);

  return (
    <TogglesContainer data-test="action-button-toggles">
      {actionButtons.map(({ title, isActive }: ActionButtonToggle, index: number) => {
        return (
          <ToggleRow data-test="action-button-toggle-row" key={`action-button-toggle-${index}`}>
            <Toggle
              size={TOGGLE_SIZES.LARGE}
              id={reformatLabelForId(title)}
              isActive={isActive}
              onClick={(newState) => handleUpdateToggleState(index, newState)}
              showCheckmarkOnActive
            />
            {isEditingTitles[index] ? (
              <>
                <InputText
                  id={`action-button-toggle-input-text-${index}`}
                  onBlur={() => handleUpdateIsEditingStates(false, index)}
                  onChange={(value) => handleUpdateName(value, index)}
                  placeholder={`Button ${index + 1}`}
                  value={title}
                  autoFocus
                />
              </>
            ) : (
              <>
                <span>{title}</span>
                <IconButton
                  data-test={`action-button-toggle-edit-button-${index + 1}`}
                  onClick={() => handleUpdateIsEditingStates(true, index)}
                  size={BUTTON_SIZES.SMALL}
                  variant={BUTTON_VARIANTS.GHOST}
                >
                  <Edit16 />
                </IconButton>
              </>
            )}
          </ToggleRow>
        );
      })}
    </TogglesContainer>
  );
};
